import type {Schemas} from 'api/dto.generated';
import {ebsApi} from 'store/ebsApi';
import type {TaskStatus, TaskV2} from './types';
import {mapTasksV2Dto} from './mappers';

export const tasksApi = ebsApi.injectEndpoints({
  //tagTypes: ['Tasks'],
  endpoints: build => ({
    getTasks: build.query<TaskV2[], void, Schemas.TaskV2Dto[]>({
      query: () => `tasksv2/open`,
      transformResponse: mapTasksV2Dto,
      //providesTags: () => [{type: 'Tasks'}],
    }),
    putTaskStatus: build.mutation<void, {id: number; status: TaskStatus}, void>(
      {
        query: ({id, status}) => ({
          url: `tasks/${id}/status`,
          method: 'PUT',
          body: {status},
        }),
      },
    ),
  }),
});

export const {useGetTasksQuery, usePutTaskStatusMutation} = tasksApi;
